import React from "react";
import axiosInstace from "../../axiosInstace";
import Toast from "../Toast/Toast";
import "./ForceRemoveMemberModal.scss";

const ForceRemoveMemberModal = ({
  projectId,
  member,
  onClose,
  onSuccess,
  onError // 👈 add this
}) => {

  const handleForceRemove = async () => {
  try {
    await axiosInstace.delete(
      `/api/emp/projects/projectmemberaccess/${projectId}/members/${member.empId}/force`
    );

    onSuccess?.("Member forcefully removed");
    onClose();
  } catch (err) {
    onError?.(
      err?.response?.data?.message ||
        "Failed to force remove member"
    );
  }
};



  return (
    <div className="ForceRemoveMemberModal-overlay">
      <div className="ForceRemoveMemberModal-container">
        <h3 className="ForceRemoveMemberModal-title">
          Force Remove Member
        </h3>

        <p className="ForceRemoveMemberModal-text">
          <strong>{member.empName}</strong> is assigned to tasks or
          todos. Force removing will unassign them from all items.
        </p>

        <div className="ForceRemoveMemberModal-actions">
          <button
            className="ForceRemoveMemberModal-cancel"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="ForceRemoveMemberModal-danger"
            onClick={handleForceRemove}
          >
            Force Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForceRemoveMemberModal;
